import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { LoadingButton } from 'base-ui'

import { FriendlyCaptchaChallenge } from '../../../friendly-captcha'

interface LoginRegistrationOneTimePasswordFormActionsProps {
  captchaDoneCallback: (fcSolution: string) => void
  isFriendlyCaptchaDone: boolean
  isMutating: boolean
  mutationError: unknown
  onBackToPassword: () => void
  onChangeEmail: () => void
}

export const LoginRegistrationOneTimePasswordFormActions: FC<
  LoginRegistrationOneTimePasswordFormActionsProps
> = ({
  captchaDoneCallback,
  isFriendlyCaptchaDone,
  isMutating,
  mutationError,
  onBackToPassword,
  onChangeEmail,
}) => {
  return (
    <>
      <LoadingButton
        className="mb-5 w-full"
        data-qa-id="otp-input-submit-button"
        disabled={!isFriendlyCaptchaDone || isMutating}
        id="otp-submit-btn"
        loading={isMutating}
        name="otp-input-submit-button"
        type="submit"
      >
        <FormattedMessage id="login.otp.sendCode" />
      </LoadingButton>
      <div className="text-center">
        <button
          className="cursor-pointer border-none bg-transparent p-0 text-left text-dark-brand underline hover:text-dark-primary-max"
          data-qa-id="otp-change-email"
          onClick={onChangeEmail}
          type="button"
        >
          <FormattedMessage id="login.otp.changeEmail" />
        </button>
      </div>
      <div className="my-4 text-center">
        <button
          className="cursor-pointer border-none bg-transparent p-0 text-left text-dark-brand underline hover:text-dark-primary-max"
          data-qa-id="otp-back-to-login-with-password"
          onClick={onBackToPassword}
          type="button"
        >
          <FormattedMessage id="login.otp.backToLoginWithPassword" />
        </button>
      </div>
      <FriendlyCaptchaChallenge
        doneCallback={captchaDoneCallback}
        startMode="auto"
        whenThisPropChangesResetCaptcha={mutationError}
      />
    </>
  )
}
